import {ModalState} from "@store/reducers/modal.reducer";

export const MODAL_DATA_SET = 'MODAL_DATA_SET';
export const MODAL_DATA_REMOVE = 'MODAL_DATA_REMOVE';

export class ModalDataSet {
  readonly type = MODAL_DATA_SET;
  constructor(public payload: ModalState) {}
}

export class ModalDataRemove {
  readonly type = MODAL_DATA_REMOVE;
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/store/actions/modal.action.ts